import { render, staticRenderFns } from "./TrangTaoDanhMucMenuHeThong.vue?vue&type=template&id=69253a10&"
import script from "./TrangTaoDanhMucMenuHeThong.vue?vue&type=script&lang=js&"
export * from "./TrangTaoDanhMucMenuHeThong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports